import React from 'react';

export const REACT_APP_APP_URL = process.env.REACT_APP_APP_URL;

export const AppSettings = React.createContext();